export default __webpack_public_path__ + "images/0x80a16016cc4a2e6a2caca8a4a498b1699ff0f844.png";